import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, Checkbox } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import StepsHeader from "../StepHeader";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'MatchFieldsHeader');
const MatchFieldsHeader = /*#__PURE__*/memo(_ref => {
  let {
    entityLabel,
    data,
    errors,
    toggleMatchMandatory,
    toggleMatchMandatoryExtra,
    toggleMatchMandatoryStandard
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const mandatoryCheckbox = useMemo(() => {
    if (data.importType === 'update') {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.matchMandatory
      }, /*#__PURE__*/React.createElement(Text, {
        className: classes.matchMandatoryText
      }, t('cfm_action_import_check_mandatory')), /*#__PURE__*/React.createElement(Checkbox, {
        color: "actionMajor",
        onChange: toggleMatchMandatory,
        checked: data.matchMandatory
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classes.matchMandatoryFieldTypes
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.matchMandatoryFieldTypesContent
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.matchMandatoryStandard
    }, /*#__PURE__*/React.createElement(Text, {
      className: classes.matchMandatoryText
    }, t('cfm_action_import_check_mandatory_standard')), /*#__PURE__*/React.createElement(Checkbox, {
      color: "actionMajor",
      onChange: toggleMatchMandatoryStandard,
      checked: data.matchMandatoryStandard,
      isDisabled: true
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.matchMandatoryExtra
    }, /*#__PURE__*/React.createElement(Text, {
      className: classes.matchMandatoryText
    }, t('cfm_action_import_check_mandatory_custom')), /*#__PURE__*/React.createElement(Checkbox, {
      color: "actionMajor",
      onChange: toggleMatchMandatoryExtra,
      checked: data.matchMandatoryExtra
    }))));
  }, [classes.matchMandatory, classes.matchMandatoryFieldTypes, classes.matchMandatoryFieldTypesContent, classes.matchMandatoryExtra, classes.matchMandatoryStandard, classes.matchMandatoryText, data.importType, data.matchMandatory, data.matchMandatoryExtra, data.matchMandatoryStandard, t, toggleMatchMandatory, toggleMatchMandatoryExtra, toggleMatchMandatoryStandard]);
  return /*#__PURE__*/React.createElement(StepsHeader, {
    title: t('cfm_label_match_fields', [entityLabel]),
    subtitle: t('cfm_label_match_fields_desc', [entityLabel]),
    errors: errors
  }, mandatoryCheckbox);
});
export default MatchFieldsHeader;